import { Button, Container, Form, Modal } from "react-bootstrap"
import DataTable from "react-data-table-component"
import { IoHomeOutline } from "react-icons/io5"
import { Op_per } from "../../../utils/Permissions"
import { FaPlus } from "react-icons/fa6"
import { useState } from "react"
import { useEffect } from "react"
import { CreateSalutation, DeleteSalutation, EditSalutation, GetAllSalutation } from "../../../utils/proxy/LeadsProxy"
import { AiFillDelete, AiTwotoneEdit } from "react-icons/ai"
import Swal from "sweetalert2"

export const LeadSalutation = () => {

    const [data, setData] = useState();
    const [id, setId] = useState();
    const [name, setName] = useState();
    const [description, setDescription] = useState();
    const [reload, SetReload] = useState(false);
    const [show, setShow] = useState(false);
    const [showedit, setShowedit] = useState(false);

    useEffect(() => {
        const getall = async () => {
            let d = await GetAllSalutation();
            if (d) {
                setData(d);
            } else {
                alert('Error', 'Issues while fetching data')
            }
        }
        getall()
        SetReload(false);
    }, [reload])

    const handleShow = () => {
        setShow(true);
    }

    const handledelete = async (id) => {
        let d = await DeleteSalutation(id);
        if (d.status === 'Success') {
            SetReload(true);
            Swal.fire({
                title: "Success!",
                text: "Salutation Deleted !!",
                icon: "success",
                confirmButtonText: "OK",
            });
        }
    }

    const handleEditShow = (row) => {
        setShowedit(true);
        setId(row.id);
        setName(row.name);
        setDescription(row.description);
    }

    const handleClose = () => {
        setShow(false)
    }

    const handleSave = async () => {
        if (name == null || name == '') {
            Swal.fire({
                title: "Warning!",
                text: "Enter Salutation !!",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else {
            let d = await CreateSalutation(name, description);
            if (d.status === 'Success') {
                setShow(false);
                SetReload(true);
                setName(null);
                setDescription(null);
                Swal.fire({
                    title: "Success!",
                    text: "New Salutation Added !!",
                    icon: "success",
                    confirmButtonText: "OK",
                });
            }
        }
    }

    const handleEditSave = async() =>{
        if (name == null || name == '') {
            Swal.fire({
                title: "Warning!",
                text: "Enter Salutation !!",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else {
            let d = await EditSalutation(id, name, description);
            if (d.status === 'Success') {
                setShowedit(false);
                SetReload(true);
                setId(null);
                setName(null);
                setDescription(null);
                Swal.fire({
                    title: "Success!",
                    text: "Salutation Edited !!",
                    icon: "success",
                    confirmButtonText: "OK",
                });
            }
        }
    }

    const columns = [
        // {
        //     name: "Id",
        //     selector: (row) => row.id,
        //   
        
        // },
        {
            name: "Salutation",
            selector: (row) => <div style={{ whiteSpace: 'normal', backgroundColor: row.name === "" || row.name === null ? "#f36e6f" : "", borderRadius: "10px", border: row.name === "" || row.name === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.name === "" || row.name === null ? "#fff" : "#000", margin: "3px", }}>{row.name ? row.name : "N/A"}</div>,

            //width: "15%",

            fontSize: 10,
            fontWeight: 'bold',
        },
        {
            name: "Description",
            selector: (row) => <div style={{ whiteSpace: 'normal', backgroundColor: row.description === "" || row.description === null ? "#f36e6f" : "", borderRadius: "10px", border: row.description === "" || row.description === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.description === "" || row.description === null ? "#fff" : "#000", margin: "3px", }}>{row.description ? row.description : "N/A"}</div>,

            //width: "15%",

            fontSize: 10,
            fontWeight: 'bold',
        },
    ];

    const CustomHeader = ({ children }) => (<div style={{ backgroundColor: 'blue', padding: '10px', color: 'white' }}>    {children}  </div>);

    if (Op_per.get().MASTERS_HOLIDAYTYPES.ALLOW_DELETE || Op_per.get().MASTERS_HOLIDAYTYPES.ALLOW_EDIT) {
        columns.push({
            name: "Actions",
            selector: (row) => (
                <div key={row.id}>
                    <AiFillDelete
                        onClick={() => handledelete(row.id)}
                        style={{ color: "#f36e6f", fontSize: 20, display: Op_per.get().MASTERS_HOLIDAYTYPES.ALLOW_DELETE ? '' : 'none' }}
                    />
                    &nbsp;&nbsp;&nbsp;
                    <AiTwotoneEdit
                        onClick={() => handleEditShow(row)}
                        style={{ color: "#9889e6", fontSize: 20, display: Op_per.get().MASTERS_HOLIDAYTYPES.ALLOW_EDIT ? '' : 'none' }}
                    />
                </div>
            ),
        })
    }

    return (
        <Container fluid style={{ minHeight: "80vh" }}>
            <div
                className="glass-body"
                style={{
                    margin: 10,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    padding: 0,
                    backgroundColor: 'transparent'
                }}
            >

                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <ul id="breadcrumb">
                        <li><a href="/"><IoHomeOutline
                            style={{ color: "white", fontSize: 20 }}
                            
                        /></a></li>
                        <li><a href="/salutation-master"><span class="icon icon-beaker"> </span>Masters</a></li>
                        <li><a href="/salutation-master"><span class="icon icon-beaker"> </span>Salutation</a></li>
                        {/* <li><a href="#"><span class="icon icon-double-angle-right"></span>Doctor</a></li> */}

                    </ul>

                </div>
            </div>

            <div className="glass-body" style={{ margin: 10 }}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                    }}
                    className="flex-column-mobile"
                >
                    <div>
                        <Form.Control
                            className="glass"
                            placeholder="Search"
                            type="text"
                            style={{ display: 'none' }}
                        //   value={searchQuery}
                        //   onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                    <div>
                        {Op_per.get().MASTERS_HOLIDAYTYPES.ALLOW_ADD ? (
                            <Button style={{ backgroundColor: "#2194f0" }} onClick={handleShow}>
                                <FaPlus />
                            </Button>
                        ) : ("")}
                    </div>
                </div>
                <div style={{ marginTop: 10 }}>
                    <DataTable
                        columns={columns}
                        data={data}
                        // progressPending={pending}
                        // selectableRows
                        // onSelectedRowsChange={({ selectedRows }) =>
                        // setSelectedRows(selectedRows)
                        //   }
                        pagination
                        customStyles={{ headRow: { style: { backgroundColor: '#c0dfff', padding: 7 }, } }}
                        CustomHeader={<CustomHeader />}
                        // actions={actionsMemo}
                        style={{ marginTop: 10 }}
                        // progressPending={pending}
                        // progressComponent={<LoadingComponent/>}
                        dense
                    />
                </div>
            </div>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Salutation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Salutation <span style={{ color: "red" }} >*</span></Form.Label>
                            <Form.Control
                                style={{
                                    height: 40,

                                    borderColor: '#ccc',
                                    borderWidth: 1,
                                    paddingHorizontal: 8,
                                    marginBottom: 16,
                                    
                                    borderRadius:10,
                                }}
                                type="text"
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Enter Salutation"
                                required
                            />
                        </Form.Group>
                        <Form.Label>Description </Form.Label>
                        <Form.Control
                            style={{
                                height: 40,

                                borderColor: '#ccc',
                                borderWidth: 1,
                                paddingHorizontal: 8,
                                marginBottom: 16,
                                
                                borderRadius:10,
                            }}
                            type="text"
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Enter Description"
                        />
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSave}
                    >
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showedit} onHide={() => setShowedit(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Salutation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Salutation <span style={{ color: "red" }} >*</span></Form.Label>
                            <Form.Control
                                style={{
                                    height: 40,

                                    borderColor: '#ccc',
                                    borderWidth: 1,
                                    paddingHorizontal: 8,
                                    marginBottom: 16,
                                    
                                    borderRadius:10,
                                }}
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Enter Salutation"
                                required
                            />
                        </Form.Group>
                        <Form.Label>Description </Form.Label>
                        <Form.Control
                            style={{
                                height: 40,

                                borderColor: '#ccc',
                                borderWidth: 1,
                                paddingHorizontal: 8,
                                marginBottom: 16,
                                
                                borderRadius:10,
                            }}
                            type="text"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Enter Description"
                        />
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowedit(false)}>
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleEditSave}
                    >
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    )
}